const PRICING_MODEL_TYPE_PAID = 'paid';
const PAYMENT_TYPE_SALESFORCE_PROVIDED = 'salesforce_provided';

/**
 * Shared pricing helpers used by both server (e.g. listing_utils) and UI (pricingHelper).
 * Lives in root src so the server can import it; pricingHelper in the UI package re-exports or delegates.
 */
export function isPaidListing(pricing: schema.oaf.Pricing | undefined): boolean {
    return pricing?.price_model_type === PRICING_MODEL_TYPE_PAID;
}

export function isPaidWithCheckout(pricing: schema.oaf.Pricing | undefined): boolean {
    const pricingModel: schema.oaf.PricingModel | undefined = pricing?.model;
    if (isPaidListing(pricing)) {
        return (pricingModel as schema.oaf.Paid).payment_type === PAYMENT_TYPE_SALESFORCE_PROVIDED;
    }
    return false;
}
